import {Origin} from "../../libs/enum/origin.enum";

/**
 * Eine erteilte Zustimmung, wie `core` sie ausliefert.
 *
 * Es gibt keinen schreibenden Weg: Eine Zustimmung entsteht bei der
 * Registrierung und wird danach nie mehr veraendert.
 */
export class AgreementDto {

  /** Fachlicher Typ, z.B. `DPA` oder `DPA_ANNEX_1`. */
  public readonly type!: string;
  /** Verzeichnisname unter `/legal` — derselbe Wert, mit dem der Text abgerufen wird. */
  public readonly document!: string;
  public readonly version!: number;
  public readonly agreedAt!: string;
  public readonly language: string | undefined;
  public readonly platform: Origin | undefined;
  /** Pruefwert ueber den angezeigten Wortlaut. Fehlt bei Zustimmungen aus der Zeit vor `/legal`. */
  public readonly textSha256: string | undefined;

  constructor(init?: Partial<AgreementDto> | undefined) {
    Object.assign(this, init);
  }
}
